import React from 'react';
import zacharyPic from '../assets/zachary.jpeg';

const SKILLS = [
  'React.js', 'TypeScript', 'JavaScript', 'Python', 'C#', 'Java', 'Go', 'SQL',
  'Node.js', '.NET', 'FastAPI', 'Spring Boot', 'PostgreSQL', 'AWS', 'Docker',
  'Kubernetes', 'Git', 'iOS Dev', 'Android Dev', 'Figma', 'Bootstrap', 'HTML & CSS',
];

const INFO = [
  { label: 'Name',       value: 'Zachary Djerdjouri' },
  { label: 'Degree',     value: 'BSc CS & Math (Co-op) · uOttawa' },
  { label: 'GPA',        value: '4.0 / 4.0 — Dean\'s List' },
  { label: 'Languages',  value: 'English & French (bilingual)' },
  { label: 'Location',   value: 'Ottawa, Canada' },
  { label: 'Status',     value: 'Available for new projects', highlight: true },
];

function InfoRow({ label, value, highlight }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.6rem 0',
        borderBottom: '1px solid var(--border)',
        fontSize: '0.88rem',
        gap: '1rem',
      }}
    >
      <span style={{ color: 'var(--muted)', fontSize: '0.76rem', textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap' }}>
        {label}
      </span>
      <span style={{ color: highlight ? '#4ade80' : 'var(--text)', fontWeight: 500, textAlign: 'right' }}>
        {value}
      </span>
    </div>
  );
}

function About() {
  return (
    <section id="about" className="section-wrapper">
      <p className="section-label">01. Who I am</p>
      <h2 className="section-title">
        About <span className="gradient-word">Me</span>
      </h2>

      {/* Bootstrap row/col grid */}
      <div className="row g-5 align-items-start">

        {/* Left column — bio text */}
        <div className="col-lg-7">
          <p style={{ color: 'var(--muted)', marginBottom: '1.1rem', fontSize: '1.02rem' }}>
            I'm <strong style={{ color: 'var(--text)' }}>Zachary</strong>, a bilingual Computer Science & Mathematics student at the{' '}
            <strong style={{ color: 'var(--text)' }}>University of Ottawa</strong>, with a 4.0 GPA and a passion for building software
            that is both technically excellent and genuinely useful.
          </p>
          <p style={{ color: 'var(--muted)', marginBottom: '1.1rem', fontSize: '1.02rem' }}>
            I'm currently a <strong style={{ color: 'var(--text)' }}>Mobile App Developer (iOS & Android) at Transport Canada</strong>,
            working on an Agile team building government digital services. I'm also an incoming{' '}
            <strong style={{ color: 'var(--text)' }}>Technical Sales & Trading Intern at Scotiabank</strong> starting September 2026.
            Previously, I built full-stack production software at <strong style={{ color: 'var(--text)' }}>Magnet Forensics</strong>,
            worked as an Embedded Software Engineer at <strong style={{ color: 'var(--text)' }}>Telesat</strong>, and developed
            data analytics tools at the <strong style={{ color: 'var(--text)' }}>National Institute of Scientific Research (INRS)</strong>.
          </p>
          <p style={{ color: 'var(--muted)', marginBottom: '1.1rem', fontSize: '1.02rem' }}>
            I'm also an NSERC award recipient and love the intersection of strong engineering and thoughtful design.
            Outside of code, I'm a huge sports fan! I play volleyball, soccer, hockey, and I'm a proud{' '}
            <strong style={{ color: 'var(--text)' }}>Canadiens de Montréal</strong> fan through and through.
            Feel free to reach out if you just want to chat hockey!
          </p>

          <div style={{ display: 'flex', flexWrap: 'wrap', marginLeft: '-0.25rem' }}>
            {SKILLS.map(s => (
              <span key={s} className="skill-tag">{s}</span>
            ))}
          </div>
        </div>

        {/* Right column — info card */}
        <div className="col-lg-5">
          <div className="dark-card p-4">
            <img
              src={zacharyPic}
              alt="Zachary Djerdjouri"
              style={{
                width: 110, height: 110,
                borderRadius: '50%',
                objectFit: 'cover',
                objectPosition: 'center top',
                marginBottom: '1.5rem',
                border: '3px solid rgba(26,108,245,0.4)',
              }}
            />

            <div>
              {INFO.map(item => (
                <InfoRow key={item.label} {...item} />
              ))}
              <div style={{ paddingTop: '0.6rem' }}>
                <InfoRow label="Email" value="zdjer050@uottawa.ca" />
              </div>
            </div>

            {/* Links */}
            <div className="d-flex gap-2 flex-wrap mt-3">
              <a href="https://www.linkedin.com/in/zachary-djerdjouri-902142212/" target="_blank" rel="noreferrer" className="ext-link">LinkedIn ↗</a>
              <a href="https://github.com/Zachdj27" target="_blank" rel="noreferrer" className="ext-link">GitHub ↗</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
